<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("edit") }} {{ $tc("tmsid", 1) }}
      </div>
    </div>
    <div class="white-wrapper">
        <div class="row justify-content-center"><h4 class="text-blue font-weight-bold mb-5">{{ movie_name }}</h4></div>
      <form>
        <div class="row justify-content-center" v-for="(movieFormat, movieIndex) in MovieFormatDetails" :key="movieIndex">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  name="format_name"
                  id="format_name"
                  v-validate="'required'"
                  v-model="movieFormat.format_name"
                  disabled
                />
                <label>{{ $tc("format", 1) }}</label>
              </div>
            </div>
          </div>
        </div>
         <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  name="tms_id"
                  id="tms_id"
                  v-validate="'required'"
                  v-model="movieFormat.tms_id"
                />
                <label>{{$t("tms")}}</label>
              </div>
            </div>
          </div>
        </div>
        </div>
      </form>
      <section>
          <div class="col-md-12 text-center">
            <button
              :disabled="btenable"
              class="btn-blue"
              @click.prevent.stop="handleSubmit"
            >
              {{ $t("update") }}
            </button>
            <b-button class="btn-outline-grey" variant="default" to="movies">{{
              $t("cancel")
            }}</b-button>
          </div>
        </section>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";

export default {
  data() {
    return {
      btenable: false,
      submitted: false,
      selectedMovieId: "",
      MovieFormatDetails: [],
      movie_name: undefined,
    };
  },
  beforeMount() {
    const { movie_id } = this.$route.query;
    this.selectedMovieId = movie_id;
    if(movie_id) {
        this.getMoviesDetails(movie_id)
    }
  },
  mounted() {
  },
  methods: {
    getMoviesDetails(movie_id) {
      let loader = this.$loading.show();
      let payload = {
        movie_id
      };
      MovieService.GetEditMoviesDetails(payload)
        .then(response => {
          const { data } = response;
          console.log("data :", data);
          if (data && data.status && data.MovieContainer) {
              this.movie_name = data.MovieContainer.movieTitle
             data.MovieContainer.movieLangaugeFormatDistributor.map((x) => {
                 this.MovieFormatDetails.push({
                     md_id: x.md_id,
                     format_name: x.mf_name +' '+ x.lang_name + ' ' + x.sound_format_name,
                     tms_id: x.tms_id
                 })
             })
          } else {
            // Show Message Here
            console.log("data.message :", data.message);
          }
          return data;
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    handleSubmit(flag) {
      this.submitted = true;
      console.log("PAyload", this.MovieFormatDetails)
      let payload = {
          MovieFormatDetails: this.MovieFormatDetails
      }
    MovieService.UpdateTSMID(payload).then((response) => {
        const{data} = response;
        if(data.status) {
            this.$router.push({path: "movies"});
            this.$toasted.show(data.message);
        } else {
            this.$toasted.show(data.message);
        }
    }).catch((err) => {
        console.log("Error", err)
    })
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MoviesComponents/editTsm.vue